// src/components/ProjectsSection.js
import "./projectSection.css";
import React, { useState } from 'react';

function ProjectSlide({ project }) {
  const [sliderValue, setSliderValue] = useState(50);

  const handleSliderChange = (e) => {
    setSliderValue(e.target.value);
  };

  return (
    <div className="project-slide">
      <div className="before-after-wrapper">
        <img src={project.before} alt="Before" className="before-image" />
        <div className="after-mask" style={{ width: `${sliderValue}%` }}>
          <img src={project.after} alt="After" className="after-image" />
        </div>
        <div className="slider-divider" style={{ left: `${sliderValue}%` }}></div>
        <input
          type="range"
          min="0"
          max="100"
          value={sliderValue}
          className="image-compare-slider"
          onChange={handleSliderChange}
        />
        <span className="before-label">Before</span>
        <span className="after-label">After</span>
      </div>
      <div className="project-info">
        {project.info.split('\n').map((line, i) => (
          <div key={i}>{line}</div>
        ))}
      </div>
    </div>
  );
}

function ProjectsSection() {
  const projects = [
    {
      after: "images/before2.jpg",
      before: "images/After2.jpg",
      info: "Sahil Luxury Apartment\nIndore",
    },
    {
      after: "images/before3.jpg",
      before: "images/after3.jpg",
      info: "Another Project\nLocation",
    },
    {
      after: "images/before4.jpg",
      before: "images/after4.jpg",
      info: "Another Project\nLocation",
    },
    {
      after: "images/Before1.jpg",
      before: "images/After1.jpg",
      info: "Another Project\nLocation",
    },
  ];

  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);

  const goToProjectSlide = (index) => {
    setCurrentProjectIndex(index);
  };

  return (
    <div className="projects-section">
      <p className="projects-text">Projects</p>
      <h2 className="transforming-spaces">Transforming Spaces</h2>
      <p className="projects-description">
        Explore our portfolio of beautifully crafted interior designs
      </p>
      <div
        className="projects-slider"
        style={{ transform: `translateX(-${currentProjectIndex * 100}%)` }}
      >
        {projects.map((project, index) => (
          <ProjectSlide key={index} project={project} />
        ))}
      </div>
      <div className="project-dots">
        {projects.map((_, index) => (
          <span
            key={index}
            className={`project-dot ${index === currentProjectIndex ? 'active' : 'non-active'}`}
            onClick={() => goToProjectSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default ProjectsSection;
